import { render, staticRenderFns } from "./MemberDetailComponent.vue?vue&type=template&id=363f91c0&scoped=true"
import script from "./MemberDetailComponent.vue?vue&type=script&lang=js"
export * from "./MemberDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f91c0",
  null
  
)

export default component.exports